import React from 'react';
import PropTypes from 'prop-types';
import sematable from 'sematable';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RLSortHeader from '../recordsList/RLSortHeader';
import RLHeaderCell from '../recordsList/RLHeaderCell';
import RLHeaderRow from '../recordsList/RLHeaderRow';
import RLTable from '../recordsList/RLTable';
import RLTableLoader from '../recordsList/RLTableLoader';
import RLRow from '../recordsList/RLRow';
import RLCell from '../recordsList/RLCell';
import { ReactComponent as CaretRightIcon } from '../../img/caret_right.svg';

const columns = [
  { key: '_id', header: 'ID', primaryKey: true },
  { key: 'name', header: 'Haus', sortable: true },
  { key: 'lda', header: 'LDA', sortable: true },
  { key: 'bst', header: 'BST', sortable: true },
  { key: 'isSAPHouseLabel', header: 'SAP-Haus', sortable: true },
];

const HousesTable = ({
  isLoading,
  headers: {
    name: nameHeader,
    lda: ldaHeader,
    bst: bstHeader,
    isSAPHouseLabel: isSAPHouseLabelHeader,
  },
  data,
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  const tableData = data.map((house) => ({
    ...house,
    isSAPHouseLabel: house.isSAPHouse ? t('Ja') : t('Nein'),
  }));

  return (
    <>
      <RLTable>
        <thead>
          <RLHeaderRow>
            <RLSortHeader {...nameHeader} />
            <RLSortHeader {...ldaHeader} />
            <RLSortHeader {...bstHeader} />
            <RLSortHeader {...isSAPHouseLabelHeader} right />
            <RLHeaderCell />
          </RLHeaderRow>
        </thead>
        <tbody>
          {tableData.map((house) => {
            const {
              _id, name, lda, bst, isSAPHouseLabel,
            } = house;
            return (
              <RLRow
                key={_id}
                onClick={() => history.push(`/houses/${_id}`)}
                role="button"
              >
                <RLCell>{name}</RLCell>
                <RLCell>{lda}</RLCell>
                <RLCell>{bst}</RLCell>
                <RLCell right>{isSAPHouseLabel}</RLCell>
                <RLCell right>
                  <CaretRightIcon />
                </RLCell>
              </RLRow>
            );
          })}
        </tbody>
      </RLTable>
      {isLoading && <RLTableLoader />}
    </>
  );
};

HousesTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  headers: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default sematable('houses', HousesTable, columns, {
  plain: true,
  sortKey: 'name',
  defaultPageSize: 9999,
});
